import { render, staticRenderFns } from "./topMsg.vue?vue&type=template&id=bc53a876&scoped=true"
import script from "./topMsg.vue?vue&type=script&lang=js"
export * from "./topMsg.vue?vue&type=script&lang=js"
import style0 from "./topMsg.vue?vue&type=style&index=0&id=bc53a876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc53a876",
  null
  
)

export default component.exports